import { render, staticRenderFns } from "./FormPageUnitSDD.vue?vue&type=template&id=2a676e50&"
import script from "./FormPageUnitSDD.vue?vue&type=script&lang=js&"
export * from "./FormPageUnitSDD.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploymentSDD/build/corpmessengerwebapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2a676e50')) {
      api.createRecord('2a676e50', component.options)
    } else {
      api.reload('2a676e50', component.options)
    }
    module.hot.accept("./FormPageUnitSDD.vue?vue&type=template&id=2a676e50&", function () {
      api.rerender('2a676e50', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/Manda/FormPageUnitSDD.vue"
export default component.exports